<template>
  <div>
    <el-dialog
      width="60%"
      center
      :title="title"
      :visible.sync="dialogVisible"
      @opened="resetForm"
      append-to-body
    >
      <el-form
        label-position="right"
        label-width="100px"
        :rules="rules"
        ref="ruleForm"
        :model="formLabelAlign"
      >
        <el-form-item label="团队名称" prop="Name">
          <el-input v-model="formLabelAlign.Name" :disabled="type===2"></el-input>
        </el-form-item>
        <el-form-item label="团队人员" prop="UserList" v-if="type!==1">
          <ayb-select-user
            ref="teamUser"
            @getValue="getSelectedUser"
            :setWidth="setWidth"
            :isContainContact="false"
          ></ayb-select-user>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="isDisable" @click="submitForm('ruleForm')">确 定</el-button>
        <el-button type="danger" @click="close">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/modules/basicData/cluster";
import folder from "@/api/modules/basicData/folder";
import { UpdateTreePathName } from "@/api/modules/basicData/basicTask";
import { mapMutations, mapState } from "vuex";
export default {
  name: "addTeam",
  components: {
  },
  data() {
    return {
      setWidth: "100%",
      dialogVisible: false,
      isdisabled: false,
      isDisable: false,
      formLabelAlign: {
        Name: "",
        UserList: []
      },
      GroupId: "",
      title: "创建团队",
      userContactArray: [],
      rules: {
        Name: [
          { required: true, message: "请输入团队名称", trigger: "blur" },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        UserList: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个团队人员",
            trigger: "change"
          }
        ]
      }
    };
  },
  props: {
    // title:{
    //   type:String,
    //   default:'创建团队'
    // },
    type: {
      //类型 0：创建团队 1：修改团队 2：添加团队人员
      type: Number,
      default: 0
    },
    userIdArr: {
      type: Array,
      default: () => {
        return [];
      }
    },
    teamInfo: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    }
  },
  watch: {
    type(val) {
      switch (val) {
        case 0:
          this.title = "创建团队";
          break;
        case 1:
          this.title = "修改团队名称";
          break;
        case 2:
          this.title = "添加团队人员";
          break;
        default:
          this.title = "创建团队";
          break;
      }
    },
    teamInfo(row) {
      this.formLabelAlign.Name = row.NODENAME;
    }
  },
  computed: {
    ...mapState({
      userId: state => state.task.userId,
      userName: state => state.task.realName
    })
  },
  methods: {
    OpenDialog(val) {
      this.dialogVisible = true;
      this.GroupId = val;
      // this.taskIds = val;
      // GetRecordsByTaskId(this.taskIds.join(","),0).then(result => {
      //   if (result) {
      //     console.log("GetRecordsByTaskId", result);
      //     this.source = result;
      //     this.filterSource = result;
      //   }
      // });
    },
    close() {
      this.dialogVisible = false;
    },
    getSelectedUser(items) {
      // 人员（包含联系人）---------------------------------------------------------------
      // let idArr = [];
      // let nameArr = [];
      // items.forEach(c => {
      //   idArr.push(c.UserId);
      // });
      // items.forEach(c => {
      //   nameArr.push(c.Name);
      // });
      // this.Alone.CreateUserName = nameArr.join(",");
      // this.$store.state.task.searchParams.CreateUserIds = idArr.join(",");
      // this.userContactArray='';
      this.formLabelAlign.UserList = items;
    },
    submitForm(formName) {
      this.isDisable = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          switch (this.type) {
            case 0: //创建团队
              this.createTeam();
              break;
            case 1: //修改团队
              this.editTeamName();
              break;
            case 2: //添加团队人员
              this.AddMember();
              break;
            default:
              this.createTeam();
              break;
          }
        } else {
          this.isDisable = false;
          return false;
        }
      });
    },
    createTeam() {
      let dt = new Date();
      api
        .NewGroupId()
        .then(GroupId => {
          if (GroupId) {
            let folderList = [
              {
                NODEID: 0,
                NODETYPE: 1,
                NODENAME: this.formLabelAlign.Name,
                CREATETIME: dt,
                // PNODEID: '',
                // PNODENAME: '',
                // PNODETYPE: '',
                RELATIONID: GroupId.replace(/"/g, ""),
                RELATIONCREATETIME: dt,
                RELATIONTYPE: "PUB_GROUP",
                RELATIONTYPENAME: "群组",
                CREATEUSERID: this.userId,
                CREATEUSERNAME: this.userName,
                CHILDRENCOUNT: 0
              }
            ];

            var data = {
              Id: GroupId.replace(/"/g, ""),
              Name: this.formLabelAlign.Name,
              GroupType: 1,
              CreateUser: this.userId,
              CreateUserName: this.userName,
              TaskId: "",
              NickName: ""
            };

            api.addCluster(data).then(res => {
              let user = this.formLabelAlign.UserList.filter(
                item => item.UserId == this.userId
              );
              if (user.length == 0) {
                //不包含当前人，添加当前人群组
                let data1 = {
                  GroupId: GroupId,
                  GroupName: this.formLabelAlign.Name,
                  CreateUser: this.userId,
                  CreateUserName: this.userName,
                  LinkId: this.userId,
                  LinkName: this.userName,
                  LinkType: 1,
                  IsAdmin: 1
                };
                api.AddClusterMember(data1).then();
              }
              this.formLabelAlign.UserList.forEach(item => {
                let data1 = {
                  GroupId: GroupId,
                  GroupName: this.formLabelAlign.Name,
                  CreateUser: this.userId,
                  CreateUserName: this.userName,
                  LinkId: item.UserId,
                  LinkName: item.Name,
                  LinkType: 1,
                  IsAdmin: item.UserId == this.userId ? 1 : 0
                };
                api.AddClusterMember(data1).then();
              });
              folder.AddTaskTreePath(folderList).then(res => {
                this.$store.dispatch("GetTaskTreePathList", {
                  IsRoot: true,
                  PermissionType: this.$store.state.folder.permissionType
                });
                this.$store.dispatch("GetMyTaskTreePath");
              });
            //this.$store.dispatch("AddTaskTreePath", folderList);
              this.$message.success("成功");
              this.dialogVisible = false;
            });
          } else {
            this.$message.error("发生错误:群组Id获取失败");
          }
          this.isDisable = false;
        })
        .catch(() => {
          this.isDisable = false;
        });
    },
    editTeamName() {
      var data = {
        Id: this.GroupId,
        Name: this.formLabelAlign.Name,
        GroupType: 1,
        CreateUser: this.teamInfo.CREATEUSERID,
        CreateUserName: this.teamInfo.CREATEUSERNAME,
        TaskId: "",
        NickName: ""
      };
      api.updateCluster(data).then(res => {
        // this.$emit('GetGroupMember',this.GroupId)
      });
      let obj = {
        Name: this.formLabelAlign.Name,
        RelationId: this.GroupId,
        NodeType: 1
      };

      UpdateTreePathName(obj)
        .then(res => {
          this.isDisable = false;
          if (res.ResultCode > 0) {
            this.$store.dispatch("GetTaskTreePathList", {
              IsRoot: true,
              PermissionType: this.$store.state.folder.permissionType
            });
            this.$store.dispatch("GetMyTaskTreePath");
            this.$emit("GetGroupMember", this.GroupId);
            this.$emit("GetGroupName", this.formLabelAlign.Name);
            this.close();
          } else {
            this.$message.error("错误,请重试！");
          }
        })
        .catch(() => {
          this.isDisable = false;
        });
    },
    AddMember() {
      console.log('formLabelAlign',this.formLabelAlign)
      console.log('userIdArr',this.userIdArr)
      let userdata = this.formLabelAlign.UserList.filter(
        item => this.userIdArr.indexOf(item.UserId) < 0
      );
      console.log('userdata',userdata)
      userdata.forEach(item => {
        let data1 = {
          GroupId: this.GroupId,
          GroupName: this.formLabelAlign.Name,
          CreateUser: this.userId,
          CreateUserName: this.userName,
          LinkId: item.UserId,
          LinkName: item.Name,
          LinkType: 1,
          IsAdmin: item.UserId == this.userId ? 1 : 0
        };
        console.log('data1',data1)
        api.AddClusterMember(data1).then(res=>{
          this.isDisable = false;
        }).catch(() => {
          this.isDisable = false;
        });
      })
      this.dialogVisible = false;
      setTimeout(() => {
         this.dialogVisible = false;
        this.$emit("GetGroupMember", this.GroupId);
      }, 500);
    },
    resetForm() {
      this.$refs.teamUser.reset();
      this.$refs["ruleForm"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>